module.exports = __webpack_public_path__ + "img/shoplazza.128e8b6d.png";